import React, { lazy } from 'react';
import get from 'lodash/get';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { FragmentWrapper } from 'app/components/FragmentWrapper';
import { FragmentNavigator } from 'app/fragments/common/FragmentNavigator';
import { OverviewStatItemProps } from 'app/fragments/overview-fragment/common/OverviewStatItem';
import { useRecoilValue } from 'recoil';
import { transactionTypeAtom } from 'app/state/recoil/atoms';

const OverviewFragment = lazy(() => import('app/fragments/overview-fragment'));
const SectorsFragment = lazy(() => import('app/fragments/sectors-fragment'));
const DonorsFragment = lazy(() => import('app/fragments/donors-fragment'));
const PublishersFragment = lazy(
  () => import('app/fragments/publishers-fragment')
);
const OrganisationsFragment = lazy(
  () => import('app/fragments/organisation-fragment')
);

interface DetailFragmentRoutesModel {
  param: string;
  subText: string;
  wikiLink?: string;
  pageTitle: string;
  detailBaseFilter: string;
  statData: OverviewStatItemProps[];
  lineData: any;
  type: string;
}

export function DetailFragmentRoutes(props: DetailFragmentRoutesModel) {
  const { path, params } = useRouteMatch();
  const pageParam = get(params, 'param', '');
  let filledPath = path.replace(':param', pageParam);
  const transactionType = useRecoilValue(transactionTypeAtom);

  if (filledPath.indexOf('(') > -1) {
    filledPath = filledPath.replace(/(?=[()])/g, '\\');
  }

  function calcTotalBudget(): number {
    let totalBudget = 0;
    props.lineData.vizData.data.map((item: any) => {
      totalBudget += item.y;
    });
    return totalBudget;
  }

  return (
    <FragmentWrapper name={props.pageTitle}>
      <FragmentNavigator
        period="1"
        items={props.statData}
        totalBudget={calcTotalBudget()}
        valueLabel={`Total ${transactionType.name}`}
      />
      <Switch>
        {/* ------------------------------------- */}
        {/* activities */}
        <Route path={`${filledPath}/projects`}>
          <OverviewFragment
            subText={props.subText}
            wikiLink={props.wikiLink}
            pageParam={props.param}
            statData={props.statData}
            pageTitle={props.pageTitle}
            detailBaseFilter={props.detailBaseFilter}
            lineData={props.lineData}
            type={props.type}
          />
        </Route>

        {/* ------------------------------------- */}
        {/* donors */}
        <Route exact path={`${filledPath}/donors`}>
          <DonorsFragment
            pageParam={props.param}
            detailBaseFilter={props.detailBaseFilter}
          />
        </Route>

        {/* ------------------------------------- */}
        {/* publishers */}
        <Route exact path={`${filledPath}/publishers`}>
          <PublishersFragment
            pageParam={props.param}
            detailBaseFilter={props.detailBaseFilter}
          />
        </Route>
        {/* ------------------------------------- */}
        {/* sectors */}
        <Route exact path={`${filledPath}/sectors`}>
          <SectorsFragment
            pageParam={props.param}
            detailBaseFilter={props.detailBaseFilter}
          />
        </Route>

        <Route exact path={`${filledPath}/organisations`}>
          <OrganisationsFragment
            pageParam={props.param}
            pageTitle={props.pageTitle}
            detailBaseFilter={props.detailBaseFilter}
            statData={props.statData}
          />
        </Route>

        <Route
          exact
          path={filledPath}
          render={(routeProps: any) => {
            routeProps.history.replace(
              `${filledPath}/projects${routeProps.location.search}`
            );
            return <React.Fragment />;
          }}
        />
      </Switch>
    </FragmentWrapper>
  );
}
